import React from "react";

import "./account.-page.styles.scss";

const AccountPage = () => (
  <div className="account-page-container">ACCOUNT PAGE</div>
);

export default AccountPage;
